module.exports = __webpack_public_path__ + "static/media/axisArrow-light.8b54b2fc.svg";